import React from "react";
import CreateAndUpdatePage from "../CreateAndUpdatePage";
function UpdatePage() {
  return <CreateAndUpdatePage isUpdate={true} />;
}

export default UpdatePage;
